import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { IGetStepCorrectionsResponseType } from './type'
import { APIInstance } from '@/utils/functions/instance'

interface IUseGetCorrectionsProps extends IApiBaseTypes<{}> {
  step: 'PERSONAL_INFO' | 'CATEGORY' | 'ADDRESS' | 'DOCUMENT' | 'CONTRACT'
}

export function useGetStepCorrections({
  step,
  data,
  disableToast,
  ...rest
}: IUseGetCorrectionsProps &
  Omit<UseQueryOptions<any>, 'queryKey' | 'queryFn'>) {
  return useQuery({
    queryKey: ['step-corrections-item', step, data],
    queryFn: async () => {
      const response = await APIInstance<IGetStepCorrectionsResponseType>({
        url: `mrf/step-corrections/${step}/`,
        params: data,
        method: 'get'
      })
      return response
    },
    select: (response) => response?.data,
    retry: 0,
    ...rest
  })
}
